import React from 'react';
import './App.module.scss';
import BaseLayoutEn from "./components/BaseLayoutEn";
import { BrowserRouter } from "react-router-dom";

function AppEn() {
   return (
      <div>
         <BrowserRouter>
            <BaseLayoutEn />
         </BrowserRouter>
      </div>
   );
}


export default AppEn;
